import type { StyleOverrides } from '@/components/ui/RichText/RichText';

import type { TextPosition, TextVerticalPosition } from './types';

export const defaultRichTextStyles: StyleOverrides = {
  h1: 'mb-4 text-4xl font-bold leading-tight text-text-slider-heading tablet:text-6xl',
  h2: 'mb-4 text-3xl font-bold leading-tight text-gray-900 tablet:text-5xl',
  h3: 'mb-3 text-2xl font-semibold text-gray-900 tablet:text-3xl',
  p: 'mb-5 text-base font-medium leading-relaxed text-text-slider-body tablet:text-lg',
  strong: 'font-bold text-text-slider-heading',
  em: 'font-normal italic text-text-slider-body',
};

export const textAlignClassMap: Record<TextPosition, string> = {
  left: 'items-start text-left',
  center: 'items-center text-center',
  right: 'items-end text-right',
};

export const buttonAlignClassMap: Record<TextPosition, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

export const backgroundPositionClassMap: Record<TextPosition, string> = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

export const mobileVerticalPositionClassMap: Record<
  TextVerticalPosition,
  string
> = {
  top: 'items-start pt-4',
  center: 'items-center',
  bottom: 'items-end pb-4',
};

export const desktopVerticalPositionClassMap: Record<
  TextVerticalPosition,
  string
> = {
  top: 'tablet:items-start tablet:pt-8 tablet:pb-0',
  center: 'tablet:items-center tablet:pt-0 tablet:pb-0',
  bottom: 'tablet:items-end tablet:pb-8 tablet:pt-0',
};

export const colSpanClassMap: Record<number, string> = {
  1: 'laptop:col-span-1',
  2: 'laptop:col-span-2',
  3: 'laptop:col-span-3',
  4: 'laptop:col-span-4',
  5: 'laptop:col-span-5',
  6: 'laptop:col-span-6',
  7: 'laptop:col-span-7',
  8: 'laptop:col-span-8',
  9: 'laptop:col-span-9',
  10: 'laptop:col-span-10',
  11: 'laptop:col-span-11',
  12: 'laptop:col-span-12',
};

export const slideVariants = {
  enter: (direction: number) => ({
    x: direction > 0 ? 80 : -80,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => ({
    x: direction > 0 ? -80 : 80,
    opacity: 0,
  }),
};
